import { render } from "./ForgottenPasswordPopup.vue?vue&type=template&id=f1fcbe9e"
import script from "./ForgottenPasswordPopup.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordPopup.vue?vue&type=script&lang=js"
script.render = render

export default script